import { useParams } from "react-router-dom";
import { useFetch } from "@/lib/useFetch";
import { Seo } from "@/lib/seo";
import { Loading } from "@/components/States";
import { NotFoundView } from "@/components/NotFoundView";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { StayAreaCard } from "@/components/Cards";
import { CTAButton } from "@/components/CTAButton";
import { Star } from "lucide-react";

export default function VenueHotelsPage() {
  const { venue: venueParam, slug, league, team } = useParams();
  const venueSlug = venueParam || slug;
  const { data, loading, error } = useFetch(`/venue-guide/${venueSlug}`, [venueSlug]);

  if (loading) return <Loading />;
  if (error || !data?.venue) return <NotFoundView />;
  const v = data.venue;

  const crumbs = league && team
    ? [{ label: "GameDay", to: "/gameday" }, { label: league.toUpperCase(), to: `/${league}` }, { label: team.replace(/-/g, " "), to: `/${league}/${team}` }, { label: v.name, to: `/${league}/${team}/${v.slug}` }, { label: "Hotels" }]
    : [{ label: "Venues" }, { label: v.name, to: `/venues/${v.slug}` }, { label: "Hotels" }];

  return (
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-12">
      <Seo title={`Hotels near ${v.name} — Best Areas & Stays | Hotelstrips`}
        description={`Where to stay near ${v.name}: ranked stay areas and recommended hotels with transit and airport guidance.`}
        image={v.image_url} path={`/venues/${v.slug}/hotels`} />
      <Breadcrumbs items={crumbs} />

      <div className="mb-8">
        <div className="overline text-primary mb-2">Hotels & stays</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter text-ink">Where to stay near {v.name}</h1>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 mb-14">
        {data.stay_areas.map((a, i) => (
          <StayAreaCard key={a.slug} area={a} index={i} ctx={{ venue: v.slug, page: `hotels_${v.slug}` }} />
        ))}
      </div>
    </div>
  );
}
